module.exports = "/_next/static/fonts/NewSpiritCondensed-Medium-68b280d581a0473c35501070d98f6b1d.woff2";